export const READONLY_TUPLE_PRIVATE = Symbol('readonly-tuple-private');
//# sourceMappingURL=privates.js.map